<div class="app-container" [class.is-mobile]="mobileQuery.matches" style="overflow: hidden;">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- LEFT: Hamburger + Title / Back arrow -->
      <div class="app-toolbar-start">
        <button *ngIf="!selectedItem" mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span *ngIf="!selectedItem" class="app-toolbar-title" i18n="@@My Projects">My Projects</span>
        <button *ngIf="selectedItem" (click)="closeDetails()" mat-icon-button>
          <mat-icon i18n-title="@@Back" title="Back" style="color: white;">{{startupService.dir === 'rtl' ? 'arrow_forward_ios' : 'arrow_back_ios'}}</mat-icon>
        </button>
        <span *ngIf="selectedItem">
          <app-project-details-top-controls [project]="selectedItem" [draft]="selectedDraft || selectedItem.primaryDraft" [book]="selectedBook || selectedItem.primaryBook" [displayCover]="displayCover" [displaySettings]="displaySettings" [editingDetails]="editingDetails" (editingDetailsChange)="editingDetailsChanged($event)" (displayCoverChange)="displayCoverChanged($event)" (displaySettingsChange)="displaySettingsChanged($event)"></app-project-details-top-controls>
        </span>
      </div>

      <!-- CENTER: Search → Filters → Actions (M3 layout order, browsing mode) -->
      <div class="app-toolbar-center" *ngIf="!selectedItem">
        <!-- C) Search (left-of-center, visually distinct) -->
        <div class="toolbar-search">
          <mat-icon>search</mat-icon>
          <input type="text" [(ngModel)]="searchString" i18n-placeholder="@@Search" placeholder="Search">
          <mat-icon *ngIf="searchString" class="toolbar-search-clear" (click)="searchString = ''">close</mat-icon>
        </div>

        <div class="toolbar-divider"></div>

        <!-- A) Filters (segmented toggle group) -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="displayMode === 'PROJECT'" (click)="displayMode = 'PROJECT'" i18n-title="grouping of books|A container that groups related Books and Drafts. Not a Draft, and not a generic 'item'.@@Project" title="Project">
            <mat-icon>article</mat-icon><span class="toolbar-btn-label" i18n="grouping of books|A container that groups related Books and Drafts. Not a Draft, and not a generic 'item'.@@Project">Project</span>
          </button>
          <button class="toolbar-filter" [class.active]="displayMode === 'DRAFT'" (click)="displayMode = 'DRAFT'" i18n-title="unfinished book record|A book that is still being edited and has not been finalised. A distinct entity from a Project, which is a folder grouping Books and Drafts.@@Draft" title="Draft">
            <mat-icon>edit_note</mat-icon><span class="toolbar-btn-label" i18n="unfinished book record|A book that is still being edited and has not been finalised. A distinct entity from a Project, which is a folder grouping Books and Drafts.@@Draft">Draft</span>
          </button>
          <button class="toolbar-filter" [class.active]="displayMode === 'BOOK'" (click)="displayMode = 'BOOK'" i18n-title="@@Book" title="Book">
            <mat-icon>menu_book</mat-icon><span class="toolbar-btn-label" i18n="@@Book">Book</span>
          </button>
        </div>
        <!-- Standalone toggle (outside segmented group) -->
        <button class="toolbar-filter-standalone" [class.active]="showOnlyPrimary" (click)="showOnlyPrimary = !showOnlyPrimary" i18n-title="@@Show Only Primary" title="Show Only Primary">
          <mat-icon>{{ showOnlyPrimary ? 'favorite' : 'favorite_border' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- B) Actions (high-emphasis, filled) -->
        <div class="toolbar-actions">
          <button class="toolbar-action toolbar-action-primary" (click)="createProject('/')" i18n-title="@@Create Project" title="Create Project">
            <mat-icon>add</mat-icon><span class="toolbar-btn-label" i18n="@@Create Project">Create Project</span>
          </button>
          <button class="toolbar-action toolbar-action-secondary" (click)="createNewFolder('/')" i18n-title="@@Create New Folder" title="Create New Folder">
            <mat-icon>create_new_folder</mat-icon><span class="toolbar-btn-label" i18n="@@Create Folder">Create Folder</span>
          </button>
          <button class="toolbar-action toolbar-action-secondary" (click)="organizeProjects()" i18n-title="@@Organize Projects" title="Organize Projects">
            <mat-icon>auto_awesome_motion</mat-icon><span class="toolbar-btn-label" i18n="@@Organize Projects">Organize Projects</span>
          </button>
        </div>
      </div>

      <!-- CENTER: Draft editing mode — Cover/Interior toggle + Page nav + PDF upload -->
      <div class="app-toolbar-center" *ngIf="selectedItem && editingDetails === 'DRAFT'">
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="displayCover" (click)="displayCover = true; displayCoverChanged(true)" i18n-title="@@Cover" title="Cover">
            <mat-icon>auto_stories</mat-icon><span class="toolbar-btn-label" i18n="@@Cover">Cover</span>
          </button>
          <button class="toolbar-filter" [class.active]="!displayCover" (click)="displayCover = false; displayCoverChanged(false)" i18n-title="@@Interior" title="Interior">
            <mat-icon>description</mat-icon><span class="toolbar-btn-label" i18n="@@Interior">Interior</span>
          </button>
        </div>

        <!-- Page range navigation (interior only) -->
        <ng-container *ngIf="!displayCover && draftComponent?.draftBodyComponent">
          <div class="toolbar-divider"></div>
          <div class="toolbar-page-nav">
            <button class="toolbar-page-nav-btn"
                    [disabled]="!draftComponent.draftBodyComponent.hasPrevPages"
                    (click)="draftComponent.draftBodyComponent.prevPageRange()"
                    i18n-title="@@Previous Pages" title="Previous Pages">
              <mat-icon>{{startupService.dir === 'rtl' ? 'chevron_right' : 'chevron_left'}}</mat-icon>
            </button>
            <span class="toolbar-page-label">{{ draftComponent.draftBodyComponent.pageRangeLabel }}</span>
            <button class="toolbar-page-nav-btn"
                    [disabled]="!draftComponent.draftBodyComponent.hasNextPages"
                    (click)="draftComponent.draftBodyComponent.nextPageRange()"
                    i18n-title="@@Next Pages" title="Next Pages">
              <mat-icon>{{startupService.dir === 'rtl' ? 'chevron_left' : 'chevron_right'}}</mat-icon>
            </button>
          </div>
        </ng-container>

        <div class="toolbar-divider"></div>

        <div class="toolbar-actions">
          <button class="toolbar-action toolbar-action-secondary toolbar-upload-btn"
                  (click)="draftFileInput.click()"
                  i18n-title="@@Upload PDF" title="Upload PDF">
            <mat-icon>cloud_upload</mat-icon>
            <span class="toolbar-btn-label">
              <ng-container *ngIf="displayCover" i18n="@@Upload Cover PDF">Upload Cover PDF</ng-container>
              <ng-container *ngIf="!displayCover" i18n="@@Upload Interior PDF">Upload Interior PDF</ng-container>
            </span>
          </button>
          <input #draftFileInput type="file" style="display:none" accept="application/pdf" (change)="onDraftFileSelected($event)">
        </div>
      </div>

      <!-- RIGHT: Active Role -->
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" opened="true">
      <mat-nav-list>
        <app-side-nav focus="library"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="projectsGridOrList" *ngIf="showSplitView || !editingDetails" [style.height]="showSplitView ? '50%' : '100%'">
          <div class="projectsTopFixedArea">

            <!--
              SELECTION BAR

              The Google Drive pattern, because that is the one the
              operator already has: a strip that appears only when
              something is selected, carrying a dismiss "X", a live
              count, and the actions that apply to the selection.

              It lives inside .projectsTopFixedArea rather than in the
              app toolbar for the same reason the two banners above it
              do — see the placement note on the orphan banner. The
              fixed-top area is layout-neutral for the outer container;
              a sibling of .projectsGridOrList would add its height on
              top of that element's height:100% and produce an outer
              scrollbar exactly the height of the bar, appearing and
              disappearing as tiles are selected.

              Hidden while a Project is open ('selectedItem'): the grid
              is not on screen then, so the bar would be offering to
              move tiles nobody can see.
            -->
            <div class="selection-bar" *ngIf="!selectedItem && hasSelection">
              <button mat-icon-button class="selection-bar-close" (click)="clearSelection()" i18n-title="@@Clear selection" title="Clear selection" i18n-aria-label="@@Clear selection" aria-label="Clear selection">
                <mat-icon>close</mat-icon>
              </button>
              <!--
                numberFormat, not a bare interpolation. Five locales
                declare a non-Western digit table and a raw {{ }} renders
                Western digits in all of them — see AGENTS.md.
              -->
              <span class="selection-bar-count"><span>{{selectionCount | numberFormat}}</span>&nbsp;<span i18n="@@selected">selected</span></span>
              <div class="selection-bar-divider"></div>
              <!--
                Actions. Move is the only one that means anything for a
                set of Projects today. Whatever is added later goes here
                AND in the right-click menu below — they are two views of
                one action list, not two lists.
              -->
              <div class="selection-bar-actions">
                <button mat-button class="selection-bar-action" (click)="moveSelectedProjects()" i18n-title="@@Move" title="Move">
                  <mat-icon>drive_file_move</mat-icon><span class="selection-bar-action-label" i18n="@@Move">Move</span>
                </button>
              </div>
            </div>
            <!--
              Orphan-heal banner. Hidden entirely when every loaded
              Book and Draft is already in a Project (`hasOrphans ===
              false`). When any orphans exist it spans the full
              width of the fixed-top area of the projects list with
              a warm gradient, an unmistakable warning icon, a live
              count, and a prominent Organize Projects button. Only
              rendered on the browsing surface (no `selectedItem`)
              — inside a Project detail view it would just be
              noise.

              Placement note: this used to be a sibling of
              `.projectsGridOrList` under `.app-content`. That made
              the banner add its height ON TOP of the list's
              `height: 100%` and forced the outer content to grow
              past the viewport, producing an outer scrollbar
              whose scroll distance was exactly the banner height.
              Tucking it inside `.projectsTopFixedArea` keeps it
              part of the fixed-top / scrolling-body strategy the
              projects grid already uses — the banner is now
              layout-neutral for the outer container.
            -->
            <div class="orphan-heal-banner"
                 *ngIf="!selectedItem && hasOrphans"
                 role="region"
                 i18n-aria-label="@@orphanHealBannerLabel"
                 aria-label="Books and drafts not yet assigned to a Project">
              <div class="orphan-heal-banner-icon">
                <mat-icon>warning_amber</mat-icon>
              </div>
              <div class="orphan-heal-banner-text">
                <div class="orphan-heal-banner-title" i18n="@@Items are not in a Project">
                  Items are not in a Project
                </div>
                <div class="orphan-heal-banner-detail">
                  <span *ngIf="orphanBookCount > 0" class="orphan-heal-banner-count-chip orphan-heal-banner-count-book">
                    <mat-icon>menu_book</mat-icon>
                    <span>{{orphanBookCount}}</span>
                    <span *ngIf="orphanBookCount === 1" i18n="@@book">book</span>
                    <span *ngIf="orphanBookCount !== 1" i18n="@@books">books</span>
                  </span>
                  <span *ngIf="orphanDraftCount > 0" class="orphan-heal-banner-count-chip orphan-heal-banner-count-draft">
                    <mat-icon>edit_note</mat-icon>
                    <span>{{orphanDraftCount}}</span>
                    <span *ngIf="orphanDraftCount === 1" i18n="@@draft">draft</span>
                    <span *ngIf="orphanDraftCount !== 1" i18n="@@drafts">drafts</span>
                  </span>
                  <span class="orphan-heal-banner-message" i18n="@@orphanHealBannerMessage">
                    are not assigned to any Project. Use Organize Projects to review and file them.
                  </span>
                </div>
              </div>
              <button mat-flat-button
                      color="warn"
                      class="orphan-heal-banner-btn"
                      (click)="organizeProjects()"
                      i18n-title="@@Organize Projects"
                      title="Organize Projects">
                <mat-icon>auto_awesome_motion</mat-icon>
                <span class="orphan-heal-banner-btn-label" i18n="@@Organize Projects">Organize Projects</span>
              </button>
            </div>
            <!--
              FOLDER PROBLEM BANNER

              A Project stores its folder as a string path; the list of folders
              that exist is a separate JSON tree on the Organization. Nothing
              keeps the two in step, so a Project can end up in a folder the
              tree has never heard of.

              That combination used to be invisible AND disabling. The grid
              shows a Project only when the selected folder matches its folder,
              and the only way to select a folder is to click it in the tree —
              so a Project in a missing folder could not be reached from this
              screen at all. The old behaviour was to add the folder back
              silently on load, which made the Project reachable again but told
              nobody anything had been wrong.

              Now the problem is named, the missing folder paths are shown, and
              the Projects themselves are listed under "My Projects" so they
              stay reachable while the tree is still wrong. Repair is a button.
            -->
            <div class="folder-problem-banner"
                 *ngIf="!selectedItem && hasFolderProblems"
                 role="region"
                 i18n-aria-label="@@folderProblemBannerLabel"
                 aria-label="Projects in folders that do not exist">
              <div class="folder-problem-banner-icon">
                <mat-icon>folder_off</mat-icon>
              </div>
              <div class="folder-problem-banner-text">
                <div class="folder-problem-banner-title" i18n="@@Some Projects are in folders that no longer exist">
                  Some Projects are in folders that no longer exist
                </div>
                <div class="folder-problem-banner-detail">
                  <span class="folder-problem-banner-message" i18n="@@folderProblemBannerMessage">
                    These Projects are listed under My Projects so you can still open them. Fix Folders adds the missing folders back, or move each Project somewhere else.
                  </span>
                </div>
                <div class="folder-problem-list">
                  <div class="folder-problem-row" *ngFor="let problem of folderProblems">
                    <mat-icon class="folder-problem-row-icon">folder_off</mat-icon>
                    <span class="folder-problem-path">{{problem.folder}}</span>
                    <span class="folder-problem-count">{{problem.projects.length | numberFormat}}</span>
                    <span *ngIf="problem.projects.length === 1" i18n="@@Project">Project</span>
                    <span *ngIf="problem.projects.length !== 1" i18n="@@Projects">Projects</span>
                  </div>
                </div>
              </div>
              <button mat-flat-button
                      color="warn"
                      class="folder-problem-banner-btn"
                      (click)="fixFolderProblems()"
                      i18n-title="@@Fix Folders"
                      title="Fix Folders">
                <mat-icon>create_new_folder</mat-icon>
                <span class="folder-problem-banner-btn-label" i18n="@@Fix Folders">Fix Folders</span>
              </button>
            </div>
            <div *ngIf="searchString" class="searchCritieriaShown" style="color: black; padding: 20px;">
              <mat-icon>search</mat-icon><span i18n="@@Search results for ">Search results for </span><span>"{{searchString.toLowerCase()}}"</span>
            </div>
            <div *ngIf="selectedFolder !== '/' && !searchString" class="folderControl">
              <div class="folderBreadCrumbs">
                <button mat-flat-button [matBadge]="folderDecendantProjectCount['']" matBadgeColor="primary" (click)="changeFolder('/')" color="primary" style="color: black; background: inherit; padding-right: 0px;" i18n="@@My Projects">My Projects</button>
                <ng-container *ngFor="let folder of Util.getCumulativeStrings(selectedFolder, '/')"><ng-container *ngIf="folder !== '/'"><mat-icon style="margin-top: 9px;">chevron_right</mat-icon><button mat-flat-button color="primary" [matBadge]="folderDecendantProjectCount[folder]" matBadgeColor="primary" (click)="changeFolder(folder)" color="primary"  style="color: black; background: inherit; padding-right: 0px; padding-left: 0px;">{{Util.getLastItem(folder, '/')}}</button></ng-container></ng-container>
              </div>
              <div class="folderDropdown">
                <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton" style="color: black;"><span i18n="@@Manage Folder">Manage Folder</span><mat-icon>keyboard_arrow_down</mat-icon></button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="createProject(selectedFolder)">
                    <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                  </button>
                  <button mat-menu-item (click)="createNewFolder(selectedFolder)">
                    <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                  </button>
                  <button mat-menu-item (click)="moveFolder(selectedFolder)">
                    <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>
                  </button>
                  <button mat-menu-item (click)="renameFolder(selectedFolder)">
                    <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                  </button>
                  <button mat-menu-item (click)="deleteFolder(selectedFolder)" *ngIf="canDeleteFolder(selectedFolder)">
                    <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                  </button>
                </mat-menu></div>
            </div>
          </div>
          <div class="projectsGrid" *ngIf="showGrid" (click)="onGridBackgroundClick($event)">
            <!-- show only folders that are a child of the selected folder -->
            <ng-container *ngIf="!searchString && projectFolders.getChildFolders(selectedFolder).length > 0">
              <div>
              <h3 class="foldersAndProjectsTitle" i18n="@@Folders">Folders</h3>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 5px;">
                <div *ngFor="let folder of getSortedChildFolders(selectedFolder)">
                  <button  [matBadge]="folderDecendantProjectCount[folder]" matBadgeColor="primary" mat-raised-button style="display: flex; padding-left:0; margin-bottom: 5px;" class="folderThumbnail" (click)="selectedFolder = folder; searchString = '';">
                    <mat-icon style="padding-left: 15px">folder</mat-icon>
                    <span style="display: flex; flex-direction: row; margin-left: 5px;"><span style="align-content: center;">{{Util.getLastItem(folder, '/')}}</span><button mat-icon-button [matMenuTriggerFor]="menu" class="manageFolderButton folderDropdown" style="margin-right: -15px; display: inline-block" (click)="$event.stopPropagation();"><mat-icon>more_vert</mat-icon></button></span>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="createProject(folder)">
                      <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                    </button>
                    <button mat-menu-item (click)="createNewFolder(folder)">
                      <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                    </button>
                    <button mat-menu-item (click)="moveFolder(folder)">
                      <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>
                    </button>
                    <button mat-menu-item (click)="renameFolder(folder)">
                      <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                    </button>
                    <button mat-menu-item (click)="deleteFolder(folder)" *ngIf="canDeleteFolder(folder)">
                      <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                    </button>
                  </mat-menu>
                </div>
                </div>
              </div>
            </ng-container>
            <!-- show any folder in the tree that matches the search string -->
            <div *ngIf="searchString">
              <h3 class="foldersAndProjectsTitle" *ngIf="projectFolders.getFlattened().length > 0" i18n="@@Folders">Folders</h3>
              <ng-container *ngFor="let folder of projectFolders.getFlattened()">
                <ng-container *ngIf="Util.getLastItem(folder, '/').toLowerCase().includes(searchString.toLowerCase())">
                  <button mat-raised-button  [matBadge]="folderDecendantProjectCount[folder]" matBadgeColor="primary" style="display: flex; float:inline-start;" class="folderThumbnail" (click)="selectedFolder = folder; searchString = '';">
                    <mat-icon>folder</mat-icon>
                    <span style="margin-left: 5px;">{{Util.getLastItem(folder, '/')}}</span>
<!--                    <div class="folderDropdown" style="display: inline">-->
                      <button mat-icon-button [matMenuTriggerFor]="menu" class="manageFolderButton folderDropdown" style="display: inline" (click)="$event.stopPropagation();"><mat-icon>more_vert</mat-icon></button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="createProject(folder)">
                          <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                        </button>
                        <button mat-menu-item (click)="createNewFolder(folder)">
                          <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                        </button>
                        <button mat-menu-item (click)="moveFolder(folder)">
                          <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>                          </button>
                        <button mat-menu-item (click)="renameFolder(folder)">
                          <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                        </button>
                        <button mat-menu-item (click)="deleteFolder(folder)" *ngIf="canDeleteFolder(folder)">
                          <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                        </button>
                      </mat-menu>
<!--                    </div>-->
                  </button>
                </ng-container>
              </ng-container>
            </div>
            <!--
              PROJECTS IN MISSING FOLDERS

              Shown at the tree root only, and only when there are any. These
              Projects claim to live in a folder the Organization's tree does
              not contain, so there is no folder to click to reach them —
              without this section they are simply unreachable from this
              screen.

              Each tile is labelled with the folder path the Project thinks it
              is in. That is the piece of information that makes the problem
              fixable: it tells the operator whether a folder was deleted out
              from under the Project (fix the tree) or the path itself is
              wrong (move the Project). The tiles are the ordinary ones, so
              everything a Project can normally do still works from here.
            -->
            <div class="missing-folder-section floatContainer"
                 *ngIf="!searchString && isRootFolderSelected && projectsInMissingFolders.length > 0">
              <h3 class="foldersAndProjectsTitle missing-folder-title">
                <mat-icon>folder_off</mat-icon>
                <span i18n="@@Projects In Folders That Do Not Exist">Projects In Folders That Do Not Exist</span>
              </h3>
              <ng-container *ngFor="let item of projectsInMissingFolders">
                <div class="missing-folder-project">
                  <div class="missing-folder-path" [title]="item.folder">
                    <mat-icon>subdirectory_arrow_right</mat-icon><span>{{item.folder}}</span>
                  </div>
                  <ng-container [ngSwitch]="displayMode">
                    <ng-container *ngSwitchCase="'PROJECT'">
                      <div class="project-tile" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                        <app-classic-project-thumbnail [project]="item" [showOnlyPrimary]="showOnlyPrimary" [projects]="items" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-classic-project-thumbnail>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BOOK'">
                      <ng-container *ngIf="item.primaryBook && !isArchived(item.primaryBook)">
                        <div class="project-tile" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                          <app-project-book-thumbnail [book]="item.primaryBook" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-book-thumbnail>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DRAFT'">
                      <ng-container *ngIf="item.primaryDraft">
                        <div class="project-tile" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                          <app-project-draft-thumbnail [draft]="item.primaryDraft" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-draft-thumbnail>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
            <div>
              <h3 class="foldersAndProjectsTitle" i18n="@@Projects">Projects</h3>
              <!--
                FIRST-RUN / EMPTY FOLDER STATE

                Rendered only when the grid would otherwise show
                nothing at all. Two wordings: `hasNothingAtAll`
                means the Organization has no Projects, Books or
                Drafts and the operator needs to be told what the
                first step IS; otherwise this is just an empty
                folder and the account has content elsewhere, so we
                only offer the action.

                Both routes into the same `createFirstProject()`
                that the toolbar button uses — the Create Project
                dialog now starts a Draft by default, which is what
                actually gets the operator to a book (title/author
                plus the interior and cover PDFs).
              -->
              <div class="projects-empty-state" *ngIf="hasNoProjectsHere && !searchString">
                <mat-icon class="projects-empty-state-icon">article</mat-icon>
                <div class="projects-empty-state-title" *ngIf="hasNothingAtAll" i18n="@@You do not have any Projects yet">
                  You do not have any Projects yet
                </div>
                <div class="projects-empty-state-title" *ngIf="!hasNothingAtAll" i18n="@@There are no Projects in this folder">
                  There are no Projects in this folder
                </div>
                <div class="projects-empty-state-detail" i18n="@@projectsEmptyStateDetail">
                  A Project holds the Draft you are working on and the Book it becomes. Create one to enter your title and author and upload your interior and cover PDFs.
                </div>
                <button mat-raised-button color="primary" class="projects-empty-state-btn" (click)="createFirstProject()">
                  <mat-icon>add</mat-icon>
                  <span i18n="@@Create Project">Create Project</span>
                </button>
              </div>
              <ng-container *ngFor="let item of items">
                <!--
                  `isProjectInFolder` rather than `selectedFolder === item.folder`.
                  The tree root is spelled two ways in this code base: `Project.folder`
                  defaults to '' while `selectedFolder` starts as '/', and a raw ===
                  between those says a Project at the root is not at the root. The
                  helper normalizes both sides (and trailing slashes) before comparing.
                -->
                <!--
                  ONE predicate for "is this Project on screen?", shared
                  with Shift+Click range selection and with the pruning
                  of a stale selection. The inline expression this
                  replaced could not be shared, and a range computed over
                  a different set than the one drawn selects tiles the
                  operator cannot see.

                  It still normalizes folder paths for the reason the old
                  comment gave: the tree root is spelled two ways here —
                  Project.folder defaults to '' while selectedFolder
                  starts as '/' — and a raw === between those says a
                  Project at the root is not at the root.
                -->
                <ng-container *ngIf="isProjectVisible(item)">
                  <ng-container [ngSwitch]="displayMode">
                    <ng-container *ngSwitchCase="'PROJECT'">
                      <div class="project-tile" style="float:left" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                        <app-classic-project-thumbnail [project]="item" [showOnlyPrimary]="showOnlyPrimary" [projects]="items" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-classic-project-thumbnail>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BOOK'">
                      <!-- Show just primary book (unless it's archived — archived Books stay in the cache for historical order resolution but are hidden from the active-catalogue Projects UI) -->
                      <ng-container *ngIf="item.primaryBook && !isArchived(item.primaryBook)">
                        <div class="project-tile" style="float:left" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                          <app-project-book-thumbnail [book]="item.primaryBook" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-book-thumbnail>
                        </div>
                      </ng-container>
                      <!-- Show the rest of the books (skipping archived ones) -->
                      <ng-container *ngIf="!showOnlyPrimary">
                        <ng-container *ngFor="let book of item.books">
                          <div class="project-tile" style="float:left" *ngIf="book != item.primaryBook && !isArchived(book)" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                            <app-project-book-thumbnail [book]="book" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-book-thumbnail>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DRAFT'">
                      <!-- Show just primary draft -->
                      <ng-container *ngIf="item.primaryDraft">
                        <div class="project-tile" style="float:left" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                          <app-project-draft-thumbnail [draft]="item.primaryDraft" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-draft-thumbnail>
                        </div>
                      </ng-container>
                      <!-- Show the other drafts -->
                      <ng-container *ngIf="!showOnlyPrimary">
                        <ng-container *ngFor="let draft of item.drafts">
                          <div class="project-tile" style="float:left" *ngIf="draft != item.primaryDraft" [class.project-tile-selected]="isSelected(item)" (click)="onProjectTileClick(item, $event)" (contextmenu)="onProjectTileContextMenu(item, $event)">
                            <app-project-draft-thumbnail [draft]="draft" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-draft-thumbnail>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!--                  <ng-container *ngIf="item['expand'] || expand; then DoExpand; else DontExpand"></ng-container>-->
                </ng-container>

                <!-- expand -->
<!--                <ng-template #DoExpand>-->
<!--                  <ng-container *ngIf="(!item.drafts || item.drafts.length === 0) && (!item.books || item.books.length === 0)">-->
<!--                    <ng-container *ngTemplateOutlet="ProductTemplate"></ng-container>-->
<!--                  </ng-container>-->
<!--                  <ng-container *ngIf="(item.drafts && item.drafts.length > 0 ? true : false ) && showDrafts">-->
<!--                    <ng-container *ngTemplateOutlet="DraftTemplate"></ng-container>-->
<!--                  </ng-container>-->
<!--                  <ng-container *ngIf="(item.books && item.books.length > 0 ? true : false ) && showBooks">-->
<!--                    <ng-container *ngTemplateOutlet="BookTemplate"></ng-container>-->
<!--                  </ng-container>-->
<!--                </ng-template>-->

<!--                &lt;!&ndash; don't expand &ndash;&gt;-->
<!--                <ng-template #DontExpand>-->
<!--                  &lt;!&ndash; both books and drafts &ndash;&gt;-->
<!--                  <ng-container *ngIf="(item.books ? item.books.length : 0) && (item.drafts ? item.drafts.length : 0)">-->
<!--                    <ng-container *ngIf="showBooks  && showDrafts">-->
<!--                      <ng-container *ngTemplateOutlet="ProductTemplate"></ng-container>-->
<!--                    </ng-container>-->
<!--                    &lt;!&ndash; both books and drafts and only show Books &ndash;&gt;-->
<!--                    <ng-container *ngIf="showBooks  && !showDrafts">-->
<!--                      <ng-container *ngTemplateOutlet="BookTemplate"></ng-container>-->
<!--                    </ng-container>-->
<!--                    &lt;!&ndash; both books and drafts and only show Drafts &ndash;&gt;-->
<!--                    <ng-container *ngIf="!showBooks  && showDrafts">-->
<!--                      <ng-container *ngTemplateOutlet="DraftTemplate"></ng-container>-->
<!--                    </ng-container>-->
<!--                  </ng-container>-->
<!--                  &lt;!&ndash; only books and show Books &ndash;&gt;-->
<!--                  <ng-container *ngIf="(item.books ? item.books.length : 0) && showBooks && !(item.drafts ? item.drafts.length : 0)">-->
<!--                    <ng-container *ngTemplateOutlet="BookTemplate"></ng-container>-->
<!--                  </ng-container>-->
<!--                  &lt;!&ndash; only drafts and show Drafts &ndash;&gt;-->
<!--                  <ng-container *ngIf="!(item.books ? item.books.length : 0) && (item.drafts ? item.drafts.length : 0) && showDrafts">-->
<!--                    <ng-container *ngTemplateOutlet="DraftTemplate"></ng-container>-->
<!--                  </ng-container>-->
<!--&lt;!&ndash;                  &lt;!&ndash; no drafts or books &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                  <ng-container *ngIf="(!item.drafts || item.drafts.length === 0) && (!item.books || item.books.length === 0)">&ndash;&gt;-->
<!--&lt;!&ndash;                    <ng-container *ngTemplateOutlet="ProductTemplate"></ng-container>&ndash;&gt;-->
<!--&lt;!&ndash;                  </ng-container>&ndash;&gt;-->
<!--                </ng-template>-->

<!--                <ng-template #ProductTemplate>-->
<!--                  <app-classic-project-thumbnail [project]="item" [projects]="items" style="float:left" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-classic-project-thumbnail>-->
<!--                </ng-template>-->

<!--                <ng-template #DraftTemplate>-->
<!--                  &lt;!&ndash; Show just primary draft &ndash;&gt;-->
<!--                  <ng-container *ngIf="item.primaryDraft">-->
<!--                    <app-project-draft-thumbnail [draft]="item.primaryDraft" style="float:left" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-draft-thumbnail>-->
<!--                  </ng-container>-->
<!--                  &lt;!&ndash; Show drafts expanded &ndash;&gt;-->
<!--                  <ng-container *ngIf="(item['expand'] || expand) && item.drafts && item.drafts.length > 1">-->
<!--                    <ng-container *ngFor="let draft of item.drafts">-->
<!--                      <app-project-draft-thumbnail *ngIf="draft != item.primaryDraft" [draft]="draft" style="float:left" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-draft-thumbnail>-->
<!--                    </ng-container>-->
<!--                  </ng-container>-->
<!--                </ng-template>-->

<!--                <ng-template #BookTemplate>-->
<!--                  &lt;!&ndash; Show just primary book &ndash;&gt;-->
<!--                  <ng-container *ngIf="item.primaryBook">-->
<!--                    <app-project-book-thumbnail [book]="item.primaryBook" style="float:left" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-book-thumbnail>-->
<!--                  </ng-container>-->
<!--                  &lt;!&ndash; Show books expanded &ndash;&gt;-->
<!--                  <ng-container *ngIf="(item['expand'] || expand) && item.books && item.books.length > 1">-->
<!--                    <ng-container *ngFor="let book of item.books">-->
<!--                      <app-project-book-thumbnail *ngIf="book != item.primaryBook" [book]="book" style="float:left" [class.selected]="item === selectedItem" (editingDetailsChange)="editingDetailsChanged($event)" (selectedItem)="selectedItemChanged($event)"></app-project-book-thumbnail>-->
<!--                    </ng-container>-->
<!--                  </ng-container>-->
<!--                </ng-template>-->
              </ng-container>
            </div>
          </div>
          <div class="projectsList" *ngIf="!showGrid">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th scope="col" style="width: 30px;"></th>
                  <th scope="col" style="width: 30px;"></th>
                  <th scope="col" style="width: 100%;" i18n="@@Name">Name</th>
                  <th scope="col" style="width: 30px;" i18n="@@Last Updated">Last Updated</th>
                  <th scope="col" style="width: 30px;"></th>
                </tr>
              </thead>
              <tbody>
                <!-- Folders -->
                <!-- show only folders that are a child of the selected folder -->
                <ng-container *ngIf="!searchString">
                  <ng-container *ngFor="let folder of projectFolders.getChildFolders(selectedFolder)">
                    <tr>
                      <td>{{folder}}</td>
                      <td><mat-icon>folder</mat-icon></td>
                      <td><button mat-raised-button class="folderThumbnailButton" color="primary" type="button" (click)="selectedFolder = folder;">{{Util.getLastItem(folder, '/')}}</button></td>
                      <td></td>
                      <td>
                        <div class="folderDropdown">
                          <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton"><mat-icon>more_vert</mat-icon></button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="createProject(folder)">
                              <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                            </button>
                            <button mat-menu-item (click)="createNewFolder(folder)">
                              <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                            </button>
                            <button mat-menu-item (click)="moveFolder(folder)">
                              <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>                          </button>
                            <button mat-menu-item (click)="renameFolder(folder)">
                              <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                            </button>
                            <button mat-menu-item (click)="deleteFolder(folder)" *ngIf="canDeleteFolder(folder)">
                              <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                            </button>
                          </mat-menu>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                <!-- show any folder in the tree that matches the search string -->
                <ng-container *ngIf="searchString">
                  <ng-container *ngFor="let folder of projectFolders.getFlattened()">
                    <ng-container *ngIf="Util.getLastItem(folder, '/').toLowerCase().includes(searchString.toLowerCase())">
                      <tr>
                        <td>{{folder}}</td>
                        <td><mat-icon>folder</mat-icon></td>
                        <td><button mat-raised-button class="folderThumbnailButton" color="primary" type="button" (click)="selectedFolder = folder;">{{Util.getLastItem(folder, '/')}}</button></td>
                        <td></td>
                        <td>
                          <div class="folderDropdown">
                            <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton"><mat-icon>more_vert</mat-icon></button>
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item (click)="createProject(folder)">
                                <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                              </button>
                              <button mat-menu-item (click)="createNewFolder(folder)">
                                <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                              </button>
                              <button mat-menu-item (click)="moveFolder(folder)">
                                <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>                          </button>
                              <button mat-menu-item (click)="renameFolder(folder)">
                                <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                              </button>
                              <button mat-menu-item (click)="deleteFolder(folder)" *ngIf="canDeleteFolder(folder)">
                                <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                              </button>
                            </mat-menu>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <!-- Projects -->
                <ng-container *ngIf="items && items.length > 0">
                  <ng-container *ngFor="let item of items">
                    <tr *ngIf="(!searchString && selectedFolder === item.folder ) || (searchString && item.name && item.name.toLowerCase().includes(searchString.toLowerCase()))">
                      <td>{{item.folder}}</td>
                      <td>
                        <div style="display: inline-block; overflow: hidden; height: 100%; min-width: 75px; min-height: 150px; max-height: 150px; position: relative;">
                          <app-project-book-cover-image *ngIf="item.primaryBook && !isArchived(item.primaryBook)" [book]="item.primaryBook"></app-project-book-cover-image>
                          <app-project-draft-cover-image *ngIf="(!item.primaryBook || isArchived(item.primaryBook)) && item.primaryDraft" [draft]="item.primaryDraft"></app-project-draft-cover-image>
                        </div>
                      </td>
                      <td><button mat-raised-button style="width:100%" color="primary" type="button" (click)="selectedItemChanged(item); editingDetails = 'PROJECT';"><ng-container>{{item.name}}</ng-container></button></td>
                      <td>{{item.lastUpdate | date: 'MM/dd/yy hh:mm:ss'}}</td>
                      <td>
                        <div class="folderDropdown">
                          <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton"><mat-icon>more_vert</mat-icon></button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="createProject(selectedFolder)">
                              <mat-icon>add</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Project">Create Project</ng-container>
                            </button>
                            <button mat-menu-item (click)="createNewFolder(selectedFolder)">
                              <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Create Folder">Create Folder</ng-container>
                            </button>
                            <button mat-menu-item (click)="moveFolder(selectedFolder)">
                              <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move Folder">Move Folder</ng-container>                          </button>
                            <button mat-menu-item (click)="renameFolder(selectedFolder)">
                              <mat-icon>edit</mat-icon><span>&nbsp;</span><ng-container i18n="@@Rename Folder">Rename Folder</ng-container>
                            </button>
                            <button mat-menu-item (click)="deleteFolder(selectedFolder)" *ngIf="canDeleteFolder(selectedFolder)">
                              <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Folder">Delete Folder</ng-container>
                            </button>
                          </mat-menu>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!--
          RIGHT-CLICK MENU

          A zero-size element parked at the pointer, which is the
          supported way to open a mat-menu at arbitrary coordinates —
          MatMenuTrigger positions relative to its host, so the host has
          to be moved rather than the panel.

          'position: fixed' and viewport coordinates from the event, so
          it is unaffected by how far .projectsGrid has been scrolled.

          matMenuContent (rather than plain content) makes the panel
          re-render on every open. The items are conditioned on
          selectionCount, which changes between openings; a statically
          rendered panel would show the item set from the first
          right-click forever.
        -->
        <div class="selection-context-menu-trigger"
             [style.left]="contextMenuPosition.x"
             [style.top]="contextMenuPosition.y"
             [matMenuTriggerFor]="selectionMenu"
             #selectionMenuTrigger="matMenuTrigger"></div>
        <mat-menu #selectionMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item *ngIf="selectionCount === 1" (click)="openSelectedProject()">
              <mat-icon>open_in_new</mat-icon><span>&nbsp;</span><ng-container i18n="@@Open">Open</ng-container>
            </button>
            <button mat-menu-item (click)="moveSelectedProjects()">
              <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move">Move</ng-container>
            </button>
            <button mat-menu-item (click)="clearSelection()">
              <mat-icon>close</mat-icon><span>&nbsp;</span><ng-container i18n="@@Clear selection">Clear selection</ng-container>
            </button>
          </ng-template>
        </mat-menu>
        <div class="oneProjectArea" *ngIf="showSplitView || editingDetails" [style.height]="showSplitView ? '50%' : '100%'">
          <ng-container *ngIf="selectedItem" [ngSwitch]="editingDetails">
            <ng-container *ngSwitchCase="'PROJECT'">
              <app-project-details [project]="selectedItem" [displayCover]="displayCover" [editingDetails]="editingDetails" (editingDetailsChange)="editingDetailsChanged($event)"></app-project-details>
            </ng-container>
            <ng-container *ngSwitchCase="'BOOK'">
              <app-project-book [book]="selectedBook || selectedItem.primaryBook" [displayCover]="displayCover" [editingDetails]="editingDetails" (editingDetailsChange)="editingDetailsChanged($event)"></app-project-book>
            </ng-container>
            <ng-container *ngSwitchCase="'DRAFT'">
              <app-project-draft #draftComponent [draft]="selectedDraft || selectedItem.primaryDraft" [displayCover]="displayCover" [editingDetails]="editingDetails" [displaySettings]="displaySettings" (editingDetailsChange)="editingDetailsChanged($event)" (displaySettingsChange)="displaySettingsChanged($event)" (displayCoverChange)="displayCoverChanged($event)"></app-project-draft>
            </ng-container>
            <ng-container *ngSwitchDefault>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
